// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1HAwe","head":"ProcedureTableInfo_head__3lRM7"};